import React, {Component} from 'react';
import ReactTable from "react-table";
import {filterCaseInsensitive} from "../shared/tableFunctions";
import FuseTheme from "../global/theme";

const styles = {
    tableHeaderTitle: {
        position: 'relative',
        backgroundColor: FuseTheme.palette.pickerHeaderColor,
        color: FuseTheme.palette.alternateTextColor,
        fontWeight: '400',
        margin: 0,
        padding: '0.5em 1em'
    },
    wrapText: {wordWrap: 'break-word'},
    dialogContent: {maxWidth: '70%'},
    tableHeader: {
        position: 'relative',
        backgroundColor: FuseTheme.palette.pickerHeaderColor,
        color: FuseTheme.palette.alternateTextColor,
        fontWeight: '400',
        margin: '20px 0 20px 0',
        padding: '0.5em 1em'
    },
    paymentLogHeader: {
        background: 'rgb(117, 117, 117)',
        padding: '.5em 1em',
        color: '#fff'
    },
    transactionRow: {
        display: 'flex',
        width: '100%',
        borderBottom: '1px solid rgb(117, 117, 117)',
    },
    transactionTitle: {
        flex: 1,
        fontWeight: 600,
        padding: '0.5em 1em',
        borderRight: '1px solid rgb(117, 117, 117)'
    },
    transactionValue: {
        flex: 2,
        padding: '0.5em 1em'
    }
};

class DialogSaleSeq extends Component {
    render() {
        const {
            data,
            payments,
            credits,
            products,
            returns,
            discounts,
            handleSortOrFilterChange
        } = this.props;

        // ReactTable headers and columns for Table
        const tableDetailsColumns = [
            {
                Header: '',
                columns: [
                    {
                        Header: 'Payment Id',
                        accessor: 'seq',
                        style: styles.wrapText,
                    },
                    {
                        Header: 'Payment Type',
                        accessor: 'type',
                        style: styles.wrapText,
                    },
                    {
                        Header: 'Currency',
                        accessor: 'currency',
                        style: styles.wrapText,
                    },
                    {
                        Header: 'Price',
                        accessor: 'subtotal',
                        style: styles.wrapText,
                    },
                    {
                        Header: 'Tax',
                        accessor: 'tax',
                        style: styles.wrapText,
                    },
                    {
                        Header: 'Additional Tax',
                        accessor: 'additional_tax_total',
                        style: styles.wrapText,
                    },
                    {
                        Header: 'Card Type',
                        accessor: 'card_type',
                        style: styles.wrapText,
                    },
                    {
                        Header: 'Last 4',
                        accessor: 'card_last4',
                        style: styles.wrapText,
                    },
                    {
                        Header: 'Card Data Source',
                        accessor: 'card_data_source',
                        style: styles.wrapText,
                    },
                    {
                        Header: 'PN Ref',
                        accessor: 'pn_ref',
                        style: styles.wrapText,
                    },
                    {
                        Header: 'Auth',
                        accessor: 'authcode',
                        style: styles.wrapText,
                    },
                    {
                        Header: 'Mode',
                        accessor: 'mode',
                        style: styles.wrapText,
                    },
                ]
            }
        ];
        const tableCreditsColumns = [
            {
                Header: '',
                columns: [
                    {
                        Header: 'Credit Id',
                        accessor: 'seq',
                        style: styles.wrapText,
                    },
                    {
                        Header: 'Payment Id',
                        accessor: 'payment_seq',
                        style: styles.wrapText,
                    },
                    {
                        Header: 'Credit Date',
                        accessor: 'credit_date',
                        style: styles.wrapText,
                    },
                    {
                        Header: 'Mode',
                        accessor: 'mode',
                        style: styles.wrapText,
                    },
                    {
                        Header: 'Auth',
                        accessor: 'authcode',
                        style: styles.wrapText,
                    },
                    {
                        Header: 'Status',
                        accessor: 'status',
                        style: styles.wrapText,
                    },
                    {
                        Header: 'Type',
                        accessor: 'type',
                        style: styles.wrapText,
                    },
                    {
                        Header: 'Currency',
                        accessor: 'currency',
                        style: styles.wrapText,
                    },
                    {
                        Header: 'Price',
                        accessor: 'subtotal',
                        style: styles.wrapText,
                    },
                    {
                        Header: 'Tax',
                        accessor: 'tax',
                        style: styles.wrapText,
                    },
                    {
                        Header: 'Additional Tax',
                        accessor: 'additional_tax_total',
                        style: styles.wrapText,
                    },
                    // {
                    //     Header: 'Card Type',
                    //     accessor: 'card_type',
                    //     style: styles.wrapText,
                    // },
                    // {
                    //     Header: 'Last 4',
                    //     accessor: 'card_last4',
                    //     style: styles.wrapText,
                    // },
                    // {
                    //     Header: 'Card Data Source',
                    //     accessor: 'card_data_source',
                    //     style: styles.wrapText,
                    // },
                    // {
                    //     Header: 'PN Ref',
                    //     accessor: 'pn_ref',
                    //     style: styles.wrapText,
                    // }
                ]
            }
        ];
        const tableDiscountsColumns = [
            {
                Header: '',
                columns: [
                    {
                        Header: 'Code',
                        accessor: 'code',
                        style: styles.wrapText,
                    },
                    {
                        Header: 'Description',
                        accessor: 'name',
                        style: styles.wrapText,
                    },
                    {
                        Header: 'Sum',
                        accessor: 'discount_each',
                        style: styles.wrapText,
                    },

                ]
            }
        ];
        const tableProductsPurchasedColumns = [
            {
                Header: '',
                columns: [
                    {
                        Header: 'Id',
                        accessor: 'product_unit_id',
                        style: styles.wrapText,
                    },
                    {
                        Header: 'Name',
                        accessor: 'product_name',
                        style: styles.wrapText,
                    },
                    {
                        Header: 'Unit Type',
                        accessor: 'product_unit_type',
                        style: styles.wrapText,
                    },
                    {
                        Header: 'Qty',
                        accessor: 'qty',
                        style: styles.wrapText,
                    },
                    {
                        Header: 'Price Subtotal',
                        accessor: 'price_subtotal_display',
                        style: styles.wrapText,
                    }
                ]
            }
        ];
        const tableProductsReturnedColumns = [
            {
                Header: '',
                columns: [
                    {
                        Header: 'Id',
                        accessor: 'product_unit_id',
                        style: styles.wrapText,
                    },
                    {
                        Header: 'Name',
                        accessor: 'product_name',
                        style: styles.wrapText,
                    },
                    {
                        Header: 'Unit Type',
                        accessor: 'product_unit_type',
                        style: styles.wrapText,
                    },
                    {
                        Header: 'Qty',
                        accessor: 'qty',
                        style: styles.wrapText,
                    }
                ]
            }
        ];

        return (
            <div className="reports-custom-table-container">
                <div className="reports-table-title" style={styles.tableHeaderTitle}>
                    <h3 style={styles.tableHeaderTitle}>
                        <span>Sales Log</span>
                    </h3>
                </div>
                <div style={styles.transactionRow}>
                    <div style={styles.transactionTitle}>Id</div>
                    <div style={styles.transactionValue}>{data.seq}</div>
                </div>
                <div style={styles.transactionRow}>
                    <div style={styles.transactionTitle}>Location</div>
                    <div style={styles.transactionValue}>{data.location}</div>
                </div>
                <div style={styles.transactionRow}>
                    <div style={styles.transactionTitle}>Transaction Date</div>
                    <div style={styles.transactionValue}>{data.transaction_date_string}</div>
                </div>
                <div style={styles.transactionRow}>
                    <div style={styles.transactionTitle}>User</div>
                    <div style={styles.transactionValue}>{data.user}</div>
                </div>
                <div style={styles.transactionRow}>
                    <div style={styles.transactionTitle}>Register</div>
                    <div style={styles.transactionValue}>{data.register}</div>
                </div>
                <div style={styles.transactionRow}>
                    <div style={styles.transactionTitle}>Device</div>
                    <div style={styles.transactionValue}>{data.device}</div>
                </div>
                <div style={styles.transactionRow}>
                    <div style={styles.transactionTitle}>Version</div>
                    <div style={styles.transactionValue}>{data.version}</div>
                </div>
                <div style={styles.transactionRow}>
                    <div style={styles.transactionTitle}>Mode</div>
                    <div style={styles.transactionValue}>{data.mode}</div>
                </div>

                { payments.length > 0 &&
                    <div>
                        <div className="reports-table-title" style={styles.tableHeader}>
                            <h3 style={styles.tableHeaderTitle}>
                                <span>Payments for Sale Id {data.seq}</span>
                            </h3>
                        </div>
                        <ReactTable
                            key="table-payments-logs-report"
                            data={payments}
                            columns={tableDetailsColumns}
                            defaultPageSize={100000}
                            showPagination={false}
                            filterable
                            defaultFilterMethod={filterCaseInsensitive}
                            onSortedChange={(e) => handleSortOrFilterChange(e, this.detailReactTable)}
                            onFilteredChange={(e) => handleSortOrFilterChange(e, this.detailReactTable)}
                            ref={(r) => this.detailReactTable = r}
                            resizable={false}
                            minRows={1}
                            className="-striped overflow"
                        />
                    </div>
                }

                { credits.length > 0 &&
                <div>
                    <div className="reports-table-title" style={styles.tableHeader}>
                        <h3 style={styles.tableHeaderTitle}>
                            <span>Credits for Sale Id {data.seq}</span>
                        </h3>
                    </div>
                    <ReactTable
                        key="table-credits-logs-report"
                        data={credits}
                        columns={tableCreditsColumns}
                        defaultPageSize={100000}
                        showPagination={false}
                        filterable
                        defaultFilterMethod={filterCaseInsensitive}
                        onSortedChange={(e) => handleSortOrFilterChange(e, this.creditsReactTable)}
                        onFilteredChange={(e) => handleSortOrFilterChange(e, this.creditsReactTable)}
                        ref={(r) => this.creditsReactTable = r}
                        resizable={false}
                        minRows={1}
                        className="-striped overflow"
                    />
                </div>
                }

                { discounts.length > 0 &&
                <div>
                    <div className="reports-table-title" style={styles.tableHeader}>
                        <h3 style={styles.tableHeaderTitle}>
                            <span>Discounts Applied</span>
                        </h3>
                    </div>
                    <ReactTable
                        key="table-products-discounts-logs-report"
                        data={discounts}
                        columns={tableDiscountsColumns}
                        defaultPageSize={100000}
                        showPagination={false}
                        filterable
                        defaultFilterMethod={filterCaseInsensitive}
                        onSortedChange={(e) => handleSortOrFilterChange(e, this.productsDiscountsReactTable)}
                        onFilteredChange={(e) => handleSortOrFilterChange(e, this.productsDiscountsReactTable)}
                        ref={(r) => this.productsDiscountsReactTable = r}
                        resizable={false}
                        minRows={1}
                        className="-striped overflow"
                    />
                </div>
                }

                { products.length > 0 &&
                <div>
                    <div className="reports-table-title" style={styles.tableHeader}>
                        <h3 style={styles.tableHeaderTitle}>
                            <span>Products Purchased</span>
                        </h3>
                    </div>
                    <ReactTable
                        key="table-products-purchased-logs-report"
                        data={products}
                        columns={tableProductsPurchasedColumns}
                        defaultPageSize={100000}
                        showPagination={false}
                        filterable
                        defaultFilterMethod={filterCaseInsensitive}
                        onSortedChange={(e) => handleSortOrFilterChange(e, this.productsPurchasedReactTable)}
                        onFilteredChange={(e) => handleSortOrFilterChange(e, this.productsPurchasedReactTable)}
                        ref={(r) => this.productsPurchasedReactTable = r}
                        resizable={false}
                        minRows={1}
                        className="-striped overflow"
                    />
                </div>
                }

                { returns.length > 0 &&
                <div>
                    <div className="reports-table-title" style={styles.tableHeader}>
                        <h3 style={styles.tableHeaderTitle}>
                            <span>Products Returned</span>
                        </h3>
                    </div>
                    <ReactTable
                        key="table-products-returned-logs-report"
                        data={returns}
                        columns={tableProductsReturnedColumns}
                        defaultPageSize={100000}
                        showPagination={false}
                        filterable
                        defaultFilterMethod={filterCaseInsensitive}
                        onSortedChange={(e) => handleSortOrFilterChange(e, this.productsReturnedReactTable)}
                        onFilteredChange={(e) => handleSortOrFilterChange(e, this.productsReturnedReactTable)}
                        ref={(r) => this.productsReturnedReactTable = r}
                        resizable={false}
                        minRows={1}
                        className="-striped overflow"
                    />
                </div>
                }

            </div>
        );
    }
}

export default DialogSaleSeq;



// WEBPACK FOOTER //
// ./src/Fuse/components/DialogSaleSeq.js